import React, { useState } from 'react'

import { useSelector } from 'react-redux'

import { RecipeTile as PureRecipeTile } from '@features/recipe-tile'
import type { RecipeTileProps } from '@features/recipe-tile/src/components/RecipeTile'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'
import { useIsRecipeInStock } from 'hooks/menu-recipes/useIsRecipeInStock'
import { useRecipeOptions } from 'routes/Menu/domains/menu'
import { getBasketRecipeNumPortionsForId } from 'selectors/basket'

export const RecipeTile = (
  props: Omit<
    RecipeTileProps,
    'alternativeOptions' | 'isOutOfStock' | 'isInBasket' | 'numPortions'
  >,
) => {
  const [shouldFetchOptions, setShouldFetchOptions] = useState(false)

  const { recipe } = props

  const { alternativeOptions, isLoadingOptions } = useRecipeOptions(recipe, shouldFetchOptions)
  const recipeNumPortions = useSelector(getBasketRecipeNumPortionsForId(recipe.id))

  const isOutOfStock = !useIsRecipeInStock(recipe.id)

  const { basketHasRecipe } = useBasketRecipes()
  const isInBasket = basketHasRecipe(recipe.id)

  return (
    <PureRecipeTile
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      alternativeOptions={alternativeOptions}
      isOutOfStock={isOutOfStock}
      isInBasket={isInBasket}
      onOpenAlternativeOptions={() => setShouldFetchOptions(true)}
      isLoadingOptions={isLoadingOptions}
      numPortions={recipeNumPortions}
    />
  )
}
